import React, { Fragment, useContext, useEffect } from 'react'

import useIsMounted from '@hooks/useIsMounted'
import { ConfigurationContext } from './provider'
import CommonService from '@services/common/common.service'
import { AuthContext } from '@contexts/Auth'

interface Props {
	children: React.ReactNode
}

const ConfigurationsWrapper: React.FC<Props> = ({ children }) => {
	const isMounted = useIsMounted()
	const { state, dispatch } = useContext(ConfigurationContext)
	const { state: userState } = useContext(AuthContext)
	console.debug('/session-timeout')

	const reload = () => {
		const promiseList: {
			dispatchAction: 'updateProjectList' | 'updateOrganizationList' | 'updateProductsList'
			promise: Promise<any>
		}[] = [
			// {
			// 	dispatchAction: 'updateProjectList',
			// 	promise: CommonService.GetProjectList({}),
			// },
			// {
			// 	dispatchAction: 'updateOrganizationList',
			// 	promise: CommonService.GetOrganizationList({}),
			// },
			// {
			// 	dispatchAction: 'updateProductsList',
			// 	promise: CommonService.GetProductsList({}),
			// },
		]

		try {
			if (userState.userInfo.id !== '') {
				promiseList?.forEach(async (promise) => {
					await promise.promise.then((results) => {
						dispatch({ type: promise.dispatchAction, options: results })
					})
				})
			}
		} catch (e: any) {
			console.log('[Error] Failed to fetch configutations options', e?.message)
		}
	}

	useEffect(() => {
		reload()
	}, [isMounted])

	return <Fragment>{children}</Fragment>
}

export default ConfigurationsWrapper
